<template>
  <div class="page-not-found">
    <div class="container-fluid">
      <h1>404</h1>
      <p class="lead">Страница не найдена</p>
    </div>
  </div>
</template>
<script>
  export default {}
</script>
<style></style>



// WEBPACK FOOTER //
// resources/assets/js/pages/not-found.vue